export const emailConstants = {
    GET_EMAIL: 'email/get'
}